import {ProductCalculationOverviewState} from './ProductCalculationOverviewState'
import * as React from 'react'
import {
    Card, CardHeader, CardText, Checkbox, TextField, CardActions, FlatButton, Paper
} from 'material-ui'
import {ProductCalculationOverviewAction} from './ProductCalculationOverviewActions'
import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'
import {highlightQuery, shouldRenderSuggestions} from '../../View/MaterialAutosuggest'
import {SuggestionsFetchRequest} from 'react-autosuggest'
import {MessageWithTranslation} from '../../Entities/MessageWithTranslation.entity.evolve'
import * as Autosuggest from 'react-autosuggest'
import TextFieldProps = __MaterialUI.TextFieldProps
import {layers} from '../../Style'

interface PropInterface {
    state: ProductCalculationOverviewState
    dispatch: (action: ProductCalculationOverviewAction) => void
}

export function ProductCalculationOverviewFilter({state, dispatch}: PropInterface) {
    let style = (state.filterOpen) ? {display: 'block'} : {display: 'none'}
    const FIXED: 'fixed' = 'fixed'
    let cardStyle = {
        ...style,
        width: '460px',
        right: '32px',
        top: '100px',
        position: FIXED,
        zIndex: layers.overlay,

    }
    let bgStyle = {
        ...style,
        height: '100%',
        width: '100%',
        position: FIXED,
        zIndex: 99
    }
    return (
        <div>
            <div
                style={bgStyle}
                onClick={(event) => {
                    dispatch({
                        type: 'CloseFilter'
                    })
                }}
            />
            <Card
                style={cardStyle}
            >
                <CardHeader
                    title="Filter"
                    style={{paddingBottom: '0'}}
                />

                {(
                    state.filter.type.value !== null &&
                    state.filter.format.value !== null &&
                    state.filter.coverage.value !== null &&
                    state.filter.print.value !== null &&
                    state.filter.paper.value !== null &&
                    state.filter.processing.value !== null
                ) &&
                <CardText>
                    Alle Filter sind gesetzt!
                </CardText>
                }
                {(
                    state.filter.type.value === null ||
                    state.filter.format.value === null ||
                    state.filter.coverage.value === null ||
                    state.filter.print.value === null ||
                    state.filter.paper.value === null ||
                    state.filter.processing.value === null
                ) &&
                <CardText style={{paddingTop: '0'}}>
                    <div style={{width: '35%', float: 'left'}}>
                        <SelectField
                            floatingLabelText="Filterattribut"
                            value={state.setAttribute}
                            onChange={(event, index, value) => dispatch({
                                type: 'FilterAttributeChanged',
                                attribute: value
                            })}
                            fullWidth={true}
                            errorText={null}
                        >
                            {state.filter.type.value === null &&
                            <MenuItem
                                value={'type'}
                                primaryText={'Typ'}
                            />
                            }
                            {state.filter.format.value === null &&
                            <MenuItem
                                value={'format'}
                                primaryText={'Format'}
                            />
                            }
                            {state.filter.coverage.value === null &&
                            <MenuItem
                                value={'coverage'}
                                primaryText={'Coverage'}
                            />
                            }
                            {state.filter.print.value === null &&
                            <MenuItem
                                value={'print'}
                                primaryText={'Druck'}
                            />
                            }
                            {state.filter.paper.value === null &&
                            <MenuItem
                                value={'paper'}
                                primaryText={'Papier'}
                            />
                            }
                            {state.filter.processing.value === null &&
                            <MenuItem
                                value={'processing'}
                                primaryText={'Verarbeitung'}
                            />
                            }
                        </SelectField>
                    </div>
                    <div style={{width: 'calc(65% - 16px)', marginLeft: '16px', float: 'left'}}>

                            <Autosuggest
                                id={'filter-search-value'}
                                suggestions={state.filterSuggestions}
                                onSuggestionsFetchRequested={
                                    (value: SuggestionsFetchRequest) => {
                                        dispatch({
                                            type: 'FetchFilterMessageSuggestions',
                                            key: state.setAttribute,
                                            value: value.value,
                                        })
                                    }}
                                onSuggestionsClearRequested={
                                    () => dispatch({
                                        type: 'ClearFilterMessageSuggestions',
                                        key: state.setAttribute
                                    })}
                                getSuggestionValue={getValuedText(state.searchValue)}
                                inputProps={{
                                    value: state.searchValue,
                                    onChange: (// tslint:disable-next-line
                                        event: any,
                                        {newValue}: { newValue: string }) => dispatch({
                                        type: 'FilterSearchValueChanged',
                                        key: state.setAttribute,
                                        value: newValue,
                                    }),
                                }}
                                onSuggestionSelected={
                                    (// tslint:disable-next-line
                                        event: any,
                                        {suggestion}: { suggestion: MessageWithTranslation }) => dispatch({
                                        type: 'FilterApplySuggestion',
                                        key: state.setAttribute,
                                        value: suggestion,
                                    })}
                                renderInputComponent={
                                    (inputProps: TextFieldProps) =>
                                        <TextField
                                            {...inputProps}
                                            floatingLabelText={'Filterbegriff'}
                                            fullWidth={true}
                                        />
                                }
                                renderSuggestionsContainer={getRenderFunctionForMessageSuggestions}
                                renderSuggestion={customRenderSuggestion(getDisplayedText)}
                                shouldRenderSuggestions={shouldRenderSuggestions}
                                allwaysRenderSuggestions={true}
                            />
                        </div>
                    <Checkbox
                        label="Nur Exakte Treffer anzeigen"
                        checked={state.exactFilter}
                        onCheck={() => dispatch({type: 'ToogleExactFilterChecked'})}
                    />
                </CardText>
                }
                <CardActions>
                    {(
                        state.filter.type.value === null ||
                        state.filter.format.value === null ||
                        state.filter.coverage.value === null ||
                        state.filter.print.value === null ||
                        state.filter.paper.value === null ||
                        state.filter.processing.value === null
                    ) &&
                    <FlatButton
                        label={'Hinzufügen'}
                        primary={true}
                        style={{float: 'right'}}
                        onClick={() => dispatch({
                            type: 'ApplyFilter'
                        })}
                    />
                    }
                    <FlatButton
                        label={'Filter zurücksetzten'}
                        style={{float: 'right'}}
                        onClick={() => dispatch({
                            type: 'ClearAllFilter'
                        })}
                    />
                    <div style={{clear: 'both'}}/>
                </CardActions>
            </Card>
        </div>
    )
}

function getValuedText(oldText: string) {
    return (message: MessageWithTranslation) => {
        if (message.id === 0) {
            return oldText
        } else {
            return message.translation
        }
    }
}

function getDisplayedText(message: MessageWithTranslation) {
    return message.translation + ' (' + message.text + ')'
}

// tslint:disable-next-line
function getRenderFunctionForMessageSuggestions({containerProps, children}: any) {
    return (
        <Paper {...containerProps}>
            {children}
        </Paper>
    )
}

function customRenderSuggestion<T>(renderSuggestionText: (value: T) => string) {
    return (suggestion: T, {query}: {
        query: string,
    }) => {

        return (
            <MenuItem style={{overflow: 'hidden', textOverflow: 'ellipsis'}}>
                {highlightQuery(query, renderSuggestionText(suggestion))}
            </MenuItem>)
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Pages/ProductCalculationOverview/ProductCalculationOverviewFilter.tsx